import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { ChapterService } from './chapter.service';
import { AuthService } from 'app/auth/auth.service';
import { TokenStorageService } from 'app/auth/token-storage.service';
import { FacetId } from '../facet/facet';
import { FacetFilterService } from '../facet/facet-filter.service';
import { routePath } from "app/shared/app.config";

export const hasChaptersGuard: CanMatchFn = () => {
  // First make sure authGuard logic handled
  const tokenService = inject(TokenStorageService);
  const authService = inject(AuthService);
  const facetFilter = inject(FacetFilterService);
  const router = inject(Router);
  if (!authService.isTokenValid(tokenService.getToken())) {
    return router.createUrlTree(['/' + routePath.login]);
  }

  // canMatchGuard logic goes here
  const chapters = inject(ChapterService);
  facetFilter.resetDates();
  return chapters.getAll(FacetId.chapter).pipe(
    map((chapters) => {
      if (chapters.length) {
        return true;
      } else {
        return router.createUrlTree([`/${routePath.myHistory}/${routePath.createPlace}`]);
      }
    }),
    catchError((error) => {
      console.error('Failed to fetch chapters', error);
      return of(false);
    }),
  );
};
